import FieldNew from 'client/components/entities/field-new/field-new'
import ContactUsField from 'client/pages/contact-us/entities/ContactUsField'
import Recaptcha from 'client/pages/contact-us/entities/Recaptcha'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { ContactUsInterface } from 'common/types/entities/ContactUsInterface'
import EntityInterface from 'common/types/entities/EntityInterface'
import { FieldInterface } from 'common/types/entities/field-interface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import { TextAreaInterface } from 'common/types/entities/TextAreaInterface'
import React from 'react'
import ContactUsButton from 'src/editor/pages/contact-us/entities/contact-us-button'
import { Form } from 'src/editor/shared/entities/form'
import { ButtonEntityInterface } from 'src/shared/entities/button/button.schema'
import { ContactUsButtonEntityInterface } from 'src/shared/entities/contact-us-button/contact-us-button-entity.schema'
import { AttachmentsInterface } from 'src/shared/types/entities/attachments-interface'
import { FormInterface } from 'src/shared/types/entities/form-interface'
import ButtonNew from '../../components/entities/button-new'
import createCommonEntityElement, {
  AdditionalProps,
} from '../createCommonEntityElement'
import Attachments from './entities/Attachments'
import ContactUs from './entities/ContactUs'
import TextArea from './entities/TextArea'

export default function createEntityElementForContactUs(
  entity: EntityInterface | OldEntityInterface,
  additionalProps: AdditionalProps,
) {
  switch (entity.type) {
    case EntityTypeEnum.ContactUs:
      return (
        <ContactUs entity={entity as ContactUsInterface} {...additionalProps} />
      )
    case EntityTypeEnum.TextArea:
      return (
        <TextArea entity={entity as TextAreaInterface} {...additionalProps} />
      )
    case EntityTypeEnum.Form:
      return <Form entity={entity as FormInterface} {...additionalProps} />
    case EntityTypeEnum.Field:
      return <FieldNew entity={entity as FieldInterface} {...additionalProps} />
    case EntityTypeEnum.ContactUsField:
      return (
        <ContactUsField
          entity={entity as FieldInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Recaptcha:
    case EntityTypeEnum.ContactUsRecaptcha:
      return (
        <Recaptcha entity={entity as RecaptchaInterface} {...additionalProps} />
      )
    case EntityTypeEnum.Button:
      return (
        <ButtonNew
          entity={entity as ButtonEntityInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.ContactUsButton:
      return (
        <ContactUsButton
          entity={entity as ContactUsButtonEntityInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Attachments:
      return (
        <Attachments
          entity={entity as AttachmentsInterface}
          {...additionalProps}
        />
      )
    default:
      return createCommonEntityElement(entity, additionalProps)
  }
}
